//--------------------------------Absent_-------------------------->


import React, { useEffect, useState, useMemo } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Button,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CircularProgress,
  Card,
  CardContent,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Snackbar,
  Alert,
  LinearProgress,
  Backdrop,
  IconButton,
  Menu,
  Tooltip,
  TextField,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TranslateIcon from "@mui/icons-material/Translate";
import LanguageIcon from "@mui/icons-material/Language";
import { useDispatch, useSelector } from "react-redux";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTheme, useMediaQuery } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  fetchEmpDiscripency,
  fetchAttendanceSummary,
  fetchLocations,
} from "../../actions/EmpDiscripencyAction";

// ------------ Translation Texts ------------
const translations = {
  en: {
    title: "Employee Absent List",
    datePicker: "Select Date",
    exportPdf: "Export PDF",
    exporting: "Exporting...",
    totalStrength: "Total Strength",
    attendance: "Attendance",
    absent: "Absent",
    location: "Location",
    strength: "Strength",
    backToSummary: "Back to Summary",
    loading: "Loading data...",
    noData: "No attendance data available for the selected date",
    noAbsent: "No absent employees found for the selected date and location",
    total: "Total",
    reportTitle: "Employee Absent Report",
    summaryReportTitle: "Attendance Summary Report",
    reportDate: "Report Date",
    summaryStats: "Summary Statistics",
    detailedData: "Detailed Absent Employee Data",
    page: "Page",
    of: "of",
    generatedOn: "Generated on",
    pdfSuccess: "PDF exported successfully!",
    pdfError: "Failed to export PDF. Please try again.",
    prepareReport: "Preparing your report...",
    language: "Language",
    allLocations: "All Locations",
    employeeName: "Employee Name",
    serviceNo: "Service No",
    position: "Position",
    absentCount: "Absent Count",
    totalAbsent: "Total Absent",
    present: "Present",
    attendanceRate: "Attendance Rate (%)",
    generatingSummary: "Generating attendance summary report...",
    generatingAbsent: "Generating absent employee report...",
    loadingLocations: "Loading locations...",
  },
  si: {
    title: "පැමිණ නොමැති සේවකයන්ගේ ලැයිස්තුව",
    datePicker: "දිනය තෝරන්න",
    exportPdf: "PDF බාගත කරන්න",
    exporting: "PDF බාගත කරමින්...",
    totalStrength: "මුළු සේවක පිරිස",
    attendance: "පැමිණි සේවකයන්",
    absent: "පැමිණ නොමැති සේවකයන්",
    location: "ස්ථානය",
    strength: "සේවක පිරිස",
    backToSummary: "සාරාංශයට ආපසු යන්න",
    loading: "දත්ත ලබා ගනිමින්...",
    noData: "තෝරාගත් දිනය සඳහා පැමිණීම් දත්ත නොමැත",
    noAbsent: "තෝරාගත් දිනය සහ ස්ථානය සඳහා පැමිණ නොමැති සේවකයන් නොමැත",
    total: "සියල්ල",
    reportTitle: "පැමිණ නොමැති සේවක වාර්තාව",
    summaryReportTitle: "පැමිණීම් සාරාංශ වාර්තාව",
    reportDate: "වාර්තා දිනය",
    summaryStats: "සාරාංශ සංඛ්‍යාලේඛන",
    detailedData: "සවිස්තරාත්මක පැමිණ නොමැති සේවක දත්ත",
    page: "පිටුව",
    of: "යි",
    generatedOn: "සෑදූ දිනය",
    pdfSuccess: "PDF ගොනුව සාර්ථකව බාගත කරන ලදී!",
    pdfError: "PDF ගොනුව බාගත කිරීම අසාර්ථක විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    prepareReport: "ඔබේ වාර්තාව සකස් කරමින්...",
    language: "භාෂාව",
    allLocations: "සියලුම ස්ථාන",
    employeeName: "සේවකයාගේ නම",
    serviceNo: "සේවා අංකය",
    position: "තනතුර",
    absentCount: "පැමිණ නොමැති ගණන",
    totalAbsent: "මුළු පැමිණ නොමැති සේවකයන්",
    present: "පැමිණි සේවකයන්",
    attendanceRate: "පැමිණීම් අනුපාතය (%)",
    generatingSummary: "පැමිණීම් සාරාංශ වාර්තාව සකස් කරමින්...",
    generatingAbsent: "පැමිණ නොමැති සේවක වාර්තාව සකස් කරමින්...",
    loadingLocations: "ස්ථාන ලබා ගනිමින්...",
  }
};

// ------------ Styles ------------
const PageContainer = styled(Box)(({ theme }) => ({
  maxWidth: "1000px",
  margin: "0 auto",
  padding: "8px 12px",
  fontFamily: "'Poppins', sans-serif",
  [theme.breakpoints.down("sm")]: {
    padding: "0px 8px",
  },
}));

const StickyCardsContainer = styled(Box)(({ theme }) => ({
  position: "sticky",
  top: 0,
  backgroundColor: "#ffffff",
  zIndex: 100,
  paddingTop: "0px",
  paddingBottom: "4px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
  [theme.breakpoints.down("sm")]: {
    position: "sticky",
    top: 0,
    backgroundColor: "#ffffff",
  },
}));

const ScrollableContent = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    maxHeight: "calc(100vh - 260px)",
    overflowY: "auto",
  },
}));

const EmployeeCard = styled(Box)(({ theme }) => ({
  padding: "10px 12px",
  borderRadius: "10px",
  marginBottom: "8px",
  boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.07)",
  backgroundColor: "#fff",
  border: "1px solid #d1d9e6",
  transition: "0.15s ease",
  "&:hover": {
    backgroundColor: "rgba(14, 60, 102, 0.06)",
    cursor: "pointer",
    transform: "translateY(-1px)",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.12)",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "8px 10px",
  },
}));

// Table Styles matching LocationBasedEmp.js
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: "10px",
  boxShadow: "0px 3px 8px rgba(0,0,0,0.07)",
  border: "1px solid #d1d9e6",
  backgroundColor: "#ffffff",
  overflow: "hidden",
  "& .MuiTable-root": {
    borderCollapse: "separate",
    borderSpacing: 0,
  },
  "&::-webkit-scrollbar": {
    width: "5px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#888",
    borderRadius: "2px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#555",
  },
  [theme.breakpoints.up("sm")]: {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "auto",
  },
  [theme.breakpoints.down("sm")]: {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "auto",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  padding: "8px 6px",
  fontSize: "13px",
  textAlign: "center",
  "&.MuiTableCell-head": {
    backgroundColor: "#154c79",
    color: "#ffffff",
    fontWeight: 600,
    letterSpacing: "0.3px",
    borderBottom: "none",
    position: "sticky",
    top: 0,
    zIndex: 10,
    "&:first-of-type": {
      borderTopLeftRadius: "10px",
    },
    "&:last-of-type": {
      borderTopRightRadius: "10px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    padding: "6px 4px",
    fontSize: "11px",
    "&.MuiTableCell-head": {
      fontSize: "12px",
    },
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  transition: "0.15s ease",
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(243, 246, 250, 0.6)",
  },
  "&:hover": {
    backgroundColor: "rgba(14, 60, 102, 0.06)",
    cursor: "pointer",
  },
  "&:last-of-type td:first-of-type": {
    borderBottomLeftRadius: "10px",
  },
  "&:last-of-type td:last-of-type": {
    borderBottomRightRadius: "10px",
  },
}));

export default function EmpDiscripency() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { 
    loading, 
    data, 
    summaryLoading, 
    summaryData, 
    locationsLoading, 
    locationsData 
  } = useSelector((state) => state.empDiscripency);

  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedLocation, setSelectedLocation] = useState("");
  const [viewMode, setViewMode] = useState("summary");
  const [exportProgress, setExportProgress] = useState(0);
  const [exporting, setExporting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [language, setLanguage] = useState('en');
  const [anchorEl, setAnchorEl] = useState(null);

  const formatDate = (dateObj) => {
    const d = new Date(dateObj);
    return d.toISOString().split("T")[0];
  };

  const t = translations[language];

  // Get location name based on language
  const getLocationName = (locationCode) => {
    const location = locationsData.find((loc) => loc.locCode === locationCode);
    if (!location) return locationCode;
    
    return language === 'si' ? getSinhalaLocationName(location.locCode) : location.locName;
  };

  // Function to get Sinhala location name (you can extend this with actual translations)
  const getSinhalaLocationName = (locationCode) => {
    // You can create a mapping here if you have Sinhala translations
    const location = locationsData.find((loc) => loc.locCode === locationCode);
    return location ? location.locName : locationCode; // Fallback to English name
  };

  // Load locations on mount
  useEffect(() => {
    dispatch(fetchLocations());
  }, [dispatch]);

  // Load attendance summary when date changes
  useEffect(() => {
    if (selectedDate) {
      dispatch(fetchAttendanceSummary(formatDate(selectedDate)));
    }
  }, [dispatch, selectedDate]);

  // Load absent details when location is selected
  useEffect(() => {
    if (selectedLocation && viewMode === "details") {
      dispatch(fetchEmpDiscripency(formatDate(selectedDate), selectedLocation));
    }
  }, [dispatch, selectedDate, selectedLocation, viewMode]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setOpenDatePicker(false);
    setViewMode("summary");
    setSelectedLocation("");
  };

  const handleLocationChange = (event) => {
    const value = event.target.value;
    setSelectedLocation(value);
    
    if (value === "") {
      setViewMode("summary");
    } else {
      setViewMode("details");
    }
  };

  const handleLocationCardClick = (locationName) => {
    const location = locationsData.find((loc) => loc.locName === locationName);
    if (location) {
      setSelectedLocation(location.locCode);
      setViewMode("details");
    }
  };

  const handleBackToSummary = () => {
    setViewMode("summary");
    setSelectedLocation("");
  };

  // Language menu handlers
  const handleLanguageMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    handleLanguageMenuClose();
  };

  // Notification handlers
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const totalEmployees = data?.length || 0;

  // Calculate totals from summary
  const summaryTotals = useMemo(() => {
    if (!summaryData || !Array.isArray(summaryData)) {
      return { totalEmp: 0, todayAtt: 0 };
    }
    return summaryData.reduce(
      (acc, item) => ({
        totalEmp: acc.totalEmp + parseInt(item.TotalEmp || 0),
        todayAtt: acc.todayAtt + parseInt(item.TodayAtt || 0),
      }),
      { totalEmp: 0, todayAtt: 0 }
    );
  }, [summaryData]);

  const totalAbsent = summaryTotals.totalEmp - summaryTotals.todayAtt;
  const activePercentage =
    summaryTotals.totalEmp > 0
      ? Math.round((summaryTotals.todayAtt / summaryTotals.totalEmp) * 100)
      : 0;

  // Sort summary data by absent count (descending)
  const sortedSummaryData = useMemo(() => {
    if (!summaryData || !Array.isArray(summaryData)) return [];
    return [...summaryData].sort((a, b) => {
      const absentA = parseInt(a.TotalEmp || 0) - parseInt(a.TodayAtt || 0);
      const absentB = parseInt(b.TotalEmp || 0) - parseInt(b.TodayAtt || 0);
      return absentB - absentA;
    });
  }, [summaryData]);

  // Enhanced Export PDF for Summary with progress and language support
  const handleExportSummaryPDF = async () => {
    if (exporting) return;
    
    try {
      setExporting(true);
      setExportProgress(10);
      
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      setExportProgress(20);

      // Title and header
      doc.setFontSize(20);
      doc.setFont("helvetica", "bold");
      doc.text(language === 'si' ? t.summaryReportTitle : "Attendance Summary Report", pageWidth / 2, 20, { align: "center" });

      setExportProgress(30);

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`${language === 'si' ? t.reportDate : "Report Date"}: ${formatDate(selectedDate)}`, 20, 35);
      doc.text(`${language === 'si' ? t.totalStrength : "Total Employees"}: ${summaryTotals.totalEmp}`, 20, 42);
      doc.text(`${language === 'si' ? t.present : "Present"}: ${summaryTotals.todayAtt} (${activePercentage}%)`, 20, 49);
      doc.text(`${language === 'si' ? t.absent : "Absent"}: ${totalAbsent}`, 20, 56);

      setExportProgress(50);

      // Generate table
      autoTable(doc, {
        startY: 65,
        head: language === 'si' 
          ? [[t.location, t.strength, t.present, t.absent, t.attendanceRate]]
          : [["Location", "Strength", "Present", "Absent", "Attendance %"]],
        body: sortedSummaryData?.map((item) => {
          const present = parseInt(item.TodayAtt || 0);
          const total = parseInt(item.TotalEmp || 0);
          const absent = total - present;
          const percentage = total > 0 ? Math.round((present / total) * 100) : 0;
          
          // Get location name
          const locationName = getLocationName(item.location) || item.location;
          
          return [
            locationName,
            total.toString(),
            present.toString(),
            absent.toString(),
            `${percentage}%`,
          ];
        }),
        styles: {
          fontSize: 9,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: [21, 76, 121],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 248, 252],
        },
        foot: [
          [
            language === 'si' ? t.total : "TOTAL",
            summaryTotals.totalEmp.toString(),
            summaryTotals.todayAtt.toString(),
            totalAbsent.toString(),
            `${activePercentage}%`,
          ],
        ],
        footStyles: {
          fillColor: [21, 76, 121],
          textColor: 255,
          fontStyle: "bold",
        },
      });

      setExportProgress(80);

      // Add footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.setTextColor(128, 128, 128);
        doc.text(
          `${language === 'si' ? t.page : "Page"} ${i} ${language === 'si' ? t.of : "of"} ${pageCount}`,
          pageWidth - 20,
          pageHeight - 10,
          { align: "right" }
        );
        doc.text(
          `${language === 'si' ? t.generatedOn : "Generated on"} ${new Date().toLocaleDateString()}`,
          20,
          pageHeight - 10
        );
      }

      setExportProgress(100);

      // Save the PDF with language-specific filename
      const filename = language === 'si'
        ? `පැමිණීම්_සාරාංශ_වාර්තා_${formatDate(selectedDate)}.pdf`
        : `Attendance_Summary_${formatDate(selectedDate)}.pdf`;
      
      doc.save(filename);
      
      showSnackbar(language === 'si' ? t.pdfSuccess : "Summary report exported successfully!", "success");
      
      setTimeout(() => {
        setExporting(false);
        setExportProgress(0);
      }, 1000);
      
    } catch (error) {
      console.error("Error generating PDF:", error);
      showSnackbar(language === 'si' ? t.pdfError : "Failed to export PDF. Please try again.", "error");
      setExporting(false);
      setExportProgress(0);
    }
  };

  // Enhanced Export PDF for Absent Details with progress and language support
  const handleExportAbsentPDF = async () => {
    if (exporting) return;
    
    try {
      setExporting(true);
      setExportProgress(10);

      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      setExportProgress(20);

      const selectedLocationName = getLocationName(selectedLocation) || t.allLocations;

      // Title and header
      doc.setFontSize(20);
      doc.setFont("helvetica", "bold");
      doc.text(language === 'si' ? t.reportTitle : "Employee Absent Report", pageWidth / 2, 20, { align: "center" });

      setExportProgress(30);

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`${language === 'si' ? t.reportDate : "Report Date"}: ${formatDate(selectedDate)}`, 20, 35);
      doc.text(`${language === 'si' ? t.location : "Location"}: ${selectedLocationName}`, 20, 42);
      doc.text(`${language === 'si' ? t.totalAbsent : "Total Absent"}: ${totalEmployees}`, 20, 49);
      doc.text(`${language === 'si' ? t.generatedOn : "Generated"}: ${new Date().toLocaleString()}`, 20, 56);

      setExportProgress(50);

      // Generate table
      autoTable(doc, {
        startY: 65,
        head: language === 'si'
          ? [["අං.", t.serviceNo, t.employeeName, t.location, t.position]]
          : [["No", "Service No", "Employee Name", "Location", "Position"]],
        body: data?.map((item, index) => [
          (index + 1).toString(),
          item.sno || "N/A",
          item.name || "N/A",
          getLocationName(item.locationCode || item.locationName) || "N/A",
          item.position || "N/A",
        ]),
        styles: {
          fontSize: 9,
          cellPadding: 4,
        },
        headStyles: {
          fillColor: [21, 76, 121],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 248, 252],
        },
        foot: [
          [
            "",
            "",
            "",
            language === 'si' ? t.totalAbsent + ":" : "Total Absent:",
            totalEmployees.toString(),
          ],
        ],
        footStyles: {
          fillColor: [21, 76, 121],
          textColor: 255,
          fontStyle: "bold",
        },
      });

      setExportProgress(80);

      // Add footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.setTextColor(128, 128, 128);
        doc.text(
          `${language === 'si' ? t.page : "Page"} ${i} ${language === 'si' ? t.of : "of"} ${pageCount}`,
          pageWidth - 20,
          pageHeight - 10,
          { align: "right" }
        );
      }

      setExportProgress(100);

      // Save the PDF with language-specific filename
      const filename = language === 'si'
        ? `පැමිණ_නොමැති_සේවක_වාර්තා_${selectedLocationName.replace(/\s+/g, '_')}_${formatDate(selectedDate)}.pdf`
        : `Absent_Report_${selectedLocationName.replace(/\s+/g, '_')}_${formatDate(selectedDate)}.pdf`;
      
      doc.save(filename);
      
      showSnackbar(language === 'si' ? t.pdfSuccess : "Absent report exported successfully!", "success");
      
      setTimeout(() => {
        setExporting(false);
        setExportProgress(0);
      }, 1000);
      
    } catch (error) {
      console.error("Error generating PDF:", error);
      showSnackbar(language === 'si' ? t.pdfError : "Failed to export PDF. Please try again.", "error");
      setExporting(false);
      setExportProgress(0);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <PageContainer>
        {/* Export Progress Backdrop */}
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          }}
          open={exporting}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              p: 4,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              maxWidth: 400,
              width: "100%",
            }}
          >
            <CircularProgress
              size={60}
              thickness={4}
              sx={{ color: "#154c79" }}
            />
            <Typography variant="h6" color="primary" fontWeight="bold">
              {viewMode === "summary" 
                ? (language === 'si' ? "සාරාංශ වාර්තාව බාගත කරමින්..." : "Exporting Summary Report...")
                : (language === 'si' ? "පැමිණ නොමැති වාර්තාව බාගත කරමින්..." : "Exporting Absent Report...")}
            </Typography>
            <Box sx={{ width: "100%", mt: 2 }}>
              <LinearProgress
                variant="determinate"
                value={exportProgress}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: viewMode === "summary" ? "#154c79" : "#2e7d32",
                  },
                }}
              />
              <Typography
                variant="body2"
                color="text.secondary"
                align="center"
                mt={1}
              >
                {exportProgress}% {language === 'si' ? "සම්පූර්ණ" : "Complete"}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" align="center">
              {viewMode === "summary" 
                ? t.generatingSummary
                : t.generatingAbsent}
            </Typography>
          </Box>
        </Backdrop>

        {/* Success/Error Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={closeSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={closeSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
            elevation={6}
            variant="filled"
          >
            {snackbar.message}
          </Alert>
        </Snackbar>

        {/* Header with Language Selector */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              color: "#0e3c66",
              textAlign: "center",
              flex: 1,
            }}
          >
            {t.title}
          </Typography>
          
          {/* Language Selector */}
          <Tooltip title={t.language}>
            <IconButton
              onClick={handleLanguageMenuOpen}
              sx={{
                backgroundColor: language === 'si' ? '#154c79' : '#f0f0f0',
                color: language === 'si' ? 'white' : '#154c79',
                '&:hover': {
                  backgroundColor: language === 'si' ? '#0D47A1' : '#e0e0e0',
                },
                width: '36px',
                height: '36px',
                ml: 1,
              }}
            >
              {language === 'si' ? (
                <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>සිං</Typography>
              ) : (
                <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>EN</Typography>
              )}
            </IconButton>
          </Tooltip>
          
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleLanguageMenuClose}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 120,
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }
            }}
          >
            <MenuItem 
              onClick={() => handleLanguageChange('en')}
              selected={language === 'en'}
              sx={{
                backgroundColor: language === 'en' ? 'rgba(21, 76, 121, 0.08)' : 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(21, 76, 121, 0.12)',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LanguageIcon sx={{ fontSize: 18, color: '#154c79' }} />
                <Typography sx={{ fontWeight: language === 'en' ? 600 : 400 }}>
                  English
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem 
              onClick={() => handleLanguageChange('si')}
              selected={language === 'si'}
              sx={{
                backgroundColor: language === 'si' ? 'rgba(21, 76, 121, 0.08)' : 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(21, 76, 121, 0.12)',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TranslateIcon sx={{ fontSize: 18, color: '#154c79' }} />
                <Typography sx={{ fontWeight: language === 'si' ? 600 : 400 }}>
                  සිංහල
                </Typography>
              </Box>
            </MenuItem>
          </Menu>
        </Box>

        {/* Date Picker, Location Dropdown, and Export Button */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mb: 1.5,
            alignItems: "center",
            flexWrap: isMobile ? "wrap" : "nowrap",
          }}
        >
          <Button
            variant="contained"
            startIcon={<CalendarTodayIcon />}
            onClick={() => setOpenDatePicker(true)}
            disabled={exporting}
            sx={{
              flex: isMobile ? 1 : 2,
              minWidth: isMobile ? "calc(50% - 4px)" : "auto",
              height: "38px",
              borderRadius: "8px",
              backgroundColor: exporting ? "#9e9e9e" : "#154c79",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "13px",
              "&:hover": { 
                backgroundColor: exporting ? "#9e9e9e" : "#0D47A1" 
              },
            }}
          >
            {formatDate(selectedDate)}
          </Button>

          <FormControl
            sx={{
              flex: isMobile ? 1 : 2,
              minWidth: isMobile ? "calc(50% - 4px)" : "auto",
            }}
            disabled={locationsLoading}
          >
            <Select
              value={selectedLocation}
              onChange={handleLocationChange}
              displayEmpty
              disabled={exporting || locationsLoading}
              sx={{
                height: "38px",
                borderRadius: "8px",
                fontSize: "13px",
                fontWeight: "bold",
                backgroundColor: exporting ? "#f5f5f5" : "#ffffff",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: exporting ? "#e0e0e0" : undefined,
                },
              }}
            >
              <MenuItem value="">
                <em>{t.allLocations}</em>
              </MenuItem>
              {locationsLoading ? (
                <MenuItem disabled>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={16} />
                    <Typography variant="body2">{t.loadingLocations}</Typography>
                  </Box>
                </MenuItem>
              ) : (
                locationsData.map((location) => (
                  <MenuItem key={location.locCode} value={location.locCode}>
                    {language === 'si' ? getSinhalaLocationName(location.locCode) : location.locName}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>

          {!summaryLoading && summaryData && summaryData.length > 0 && (
            <Button
              variant="contained"
              startIcon={<PictureAsPdfIcon />}
              onClick={
                viewMode === "summary"
                  ? handleExportSummaryPDF
                  : handleExportAbsentPDF
              }
              disabled={exporting || (viewMode === "details" && (!data || data.length === 0))}
              sx={{
                flex: isMobile ? 1 : 1,
                minWidth: isMobile ? "100%" : "auto",
                height: "38px",
                borderRadius: "8px",
                backgroundColor: exporting 
                  ? "#9e9e9e" 
                  : (viewMode === "details" && (!data || data.length === 0) 
                    ? "#bdbdbd" 
                    : viewMode === "summary" 
                    ? "#097721" 
                    : "#2e7d32"),
                color: "#fff",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: "13px",
                "&:hover": { 
                  backgroundColor: exporting 
                    ? "#9e9e9e" 
                    : (viewMode === "details" && (!data || data.length === 0) 
                      ? "#bdbdbd" 
                      : viewMode === "summary" 
                      ? "#0D47A1" 
                      : "#1b5e20") 
                },
              }}
            >
              {exporting ? t.exporting : t.exportPdf}
            </Button>
          )}
        </Box>

        {openDatePicker && (
          <DatePicker
            open={openDatePicker}
            onClose={() => setOpenDatePicker(false)}
            value={selectedDate}
            onChange={handleDateChange}
            renderInput={(params) => (
              <TextField {...params} sx={{ display: "none" }} />
            )}
          />
        )}

        {/* Sticky Stats Cards */}
        {!summaryLoading && summaryData && summaryData.length > 0 && (
          <StickyCardsContainer>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              {/* Total Strength Card */}
              <Box
                sx={{
                  background: "linear-gradient(135deg, #e8f0fa 0%, #d4e3f7 100%)",
                  border: "1px solid #aec4e0",
                  padding: "6px 8px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontWeight: 600,
                  color: "#0E3C66",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Typography
                  sx={{ fontSize: isMobile ? "9px" : "10px", fontWeight: 500, mb: 0.2 }}
                >
                  {t.totalStrength}
                </Typography>
                <Typography sx={{ fontSize: isMobile ? "15px" : "18px", fontWeight: 800 }}>
                  {summaryTotals.totalEmp}
                </Typography>
              </Box>

              {/* Attendance Card */}
              <Box
                sx={{
                  background: "linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%)",
                  border: "1px solid #80cbc4",
                  padding: "6px 8px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontWeight: 600,
                  color: "#004d40",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Typography
                  sx={{ fontSize: isMobile ? "9px" : "10px", fontWeight: 500, mb: 0.2 }}
                >
                  {t.attendance}
                </Typography>
                <Typography sx={{ fontSize: isMobile ? "15px" : "18px", fontWeight: 800 }}>
                  {summaryTotals.todayAtt}
                </Typography>
                <Typography
                  sx={{
                    fontSize: isMobile ? "9px" : "10px",
                    fontWeight: 700,
                    color:
                      activePercentage > 70
                        ? "#2E7D32"
                        : activePercentage > 50
                        ? "#FF9800"
                        : "#D32F2F",
                  }}
                >
                  ({activePercentage}%)
                </Typography>
              </Box>

              {/* Absent Card */}
              <Box
                sx={{
                  background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
                  border: "1px solid #ef9a9a",
                  padding: "6px 8px",
                  borderRadius: "6px",
                  textAlign: "center",
                  fontWeight: 600,
                  color: "#b71c1c",
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Typography
                  sx={{ fontSize: isMobile ? "9px" : "10px", fontWeight: 500, mb: 0.2 }}
                >
                  {t.absent}
                </Typography>
                <Typography sx={{ fontSize: isMobile ? "15px" : "18px", fontWeight: 800 }}>
                  {totalAbsent}
                </Typography>
                <Typography
                  sx={{
                    fontSize: isMobile ? "9px" : "10px",
                    fontWeight: 700,
                    color: "#D32F2F",
                  }}
                >
                  ({100 - activePercentage}%)
                </Typography>
              </Box>
            </Box>
          </StickyCardsContainer>
        )}

        <ScrollableContent>
          {viewMode === "summary" ? (
            // Summary View - TABLE with all locations and scroll
            summaryLoading ? (
              <Box sx={{ textAlign: "center", padding: "40px" }}>
                <CircularProgress sx={{ color: "#154c79" }} />
                <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
                  {t.loading}
                </Typography>
              </Box>
            ) : sortedSummaryData && sortedSummaryData.length > 0 ? (
              <StyledTableContainer component={Paper} sx={{ mt: 2 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>{t.location}</StyledTableCell>
                      <StyledTableCell>{t.strength}</StyledTableCell>
                      <StyledTableCell>{t.absent}</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedSummaryData.map((row, index) => {
                      const absentCount = parseInt(row.TotalEmp || 0) - parseInt(row.TodayAtt || 0);
                      
                      return (
                        <StyledTableRow 
                          key={index}
                          onClick={() => handleLocationCardClick(row.location)}
                        >
                          <StyledTableCell
                            sx={{
                              textAlign: "left",
                              pl: isMobile ? 2 : 3,
                              maxWidth: "200px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {getLocationName(row.location) || row.location}
                          </StyledTableCell>
                          <StyledTableCell>{row.TotalEmp}</StyledTableCell>
                          <StyledTableCell>
                            <Typography
                              sx={{
                                fontWeight: 700,
                                color: absentCount > 0 ? "#D32F2F" : "#2E7D32",
                                fontSize: "13px",
                              }}
                            >
                              {absentCount}
                            </Typography>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                    
                    {/* Total Row */}
                    <StyledTableRow
                      sx={{
                        backgroundColor: "#154c79 !important",
                        "&:hover": { backgroundColor: "#154c79 !important" },
                        position: "sticky",
                        bottom: 0,
                        zIndex: 5,
                      }}
                    >
                      <StyledTableCell
                        sx={{
                          color: "#ffffff",
                          fontWeight: 700,
                          textAlign: "left",
                          pl: isMobile ? 2 : 3,
                        }}
                      >
                        {t.total}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{ color: "#ffffff", fontWeight: 700 }}
                      >
                        {summaryTotals.totalEmp}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{ color: "#ffffff", fontWeight: 700 }}
                      >
                        {totalAbsent}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </StyledTableContainer>
            ) : (
              <Typography
                variant="body1"
                sx={{ textAlign: "center", padding: "40px", color: "#666", fontStyle: "italic" }}
              >
                {t.noData}
              </Typography>
            )
          ) : (
            // Details View - Employee Cards
            <>
              {viewMode === "details" && (
                <Box sx={{ mb: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
                  <Button
                    variant="text"
                    startIcon={<ArrowBackIcon />}
                    onClick={handleBackToSummary}
                    sx={{
                      textTransform: "none",
                      fontWeight: "bold",
                      color: "#154c79",
                      fontSize: "13px",
                    }}
                  >
                    {t.backToSummary}
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "bold",
                      color: "#D32F2F",
                      fontSize: "13px",
                    }}
                  >
                    {t.totalAbsent}: {totalEmployees}
                  </Typography>
                </Box>
              )}

              {loading ? (
                <Box sx={{ textAlign: "center", padding: "40px" }}>
                  <CircularProgress sx={{ color: "#154c79" }} />
                  <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
                    {t.loading}
                  </Typography>
                </Box>
              ) : data && data.length > 0 ? (
                data.map((item, index) => (
                  <EmployeeCard key={index}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      {/* Employee Image */}
                      <img
                        src={`/api/placeholder/50/50`}
                        alt={item.name}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "2px solid #154c79",
                        }}
                        onError={(e) => (e.target.src = "/placeholder-image.jpg")}
                      />

                      {/* Employee Details */}
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="caption"
                          fontWeight="bold"
                          sx={{ color: "#154c79", display: "block", fontSize: "11px" }}
                        >
                          {item.sno}
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="600"
                          sx={{ fontSize: "14px" }}
                        >
                          {item.name}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "#666", display: "block", fontSize: "11px" }}
                        >
                          {getLocationName(item.locationCode || item.locationName)}
                        </Typography>
                      </Box>
                    </Box>
                  </EmployeeCard>
                ))
              ) : (
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", padding: "40px", color: "#666", fontStyle: "italic" }}
                >
                  {t.noAbsent}
                </Typography>
              )}
            </>
          )}
        </ScrollableContent>
      </PageContainer>
    </LocalizationProvider>
  );
}



// import React, { useEffect, useState, useMemo } from "react";
// import { styled } from "@mui/material/styles";
// import {
//   Box,
//   Typography,
//   Button,
//   Grid,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   CircularProgress,
//   Card,
//   CardContent,
//   Paper,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   TableContainer,
//   Snackbar,
//   Alert,
//   LinearProgress,
//   Backdrop,
// } from "@mui/material";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { useDispatch, useSelector } from "react-redux";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { useTheme, useMediaQuery } from "@mui/material";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import {
//   fetchEmpDiscripency,
//   fetchAttendanceSummary,
// } from "../../actions/EmpDiscripencyAction";

// // Location mapping
// const LOCATION_MAP = [
//   { name: "Administrative Office", code: "ADMN" },
//   { name: "Multifunction Building", code: "MFBD" },
//   { name: "Cleaning Unit (Inside)", code: "CLIN" },
//   { name: "Cleaning Unit (Outside)", code: "CLOS" },
//   { name: "Cleaning Unit (Special)", code: "CLSP" },
//   { name: "Cashier", code: "CASH" },
//   { name: "Dalada Museum", code: "DDMS" },
//   { name: "Dana Shalawa", code: "DANA" },
//   { name: "Ethgala Office", code: "EGLO" },
//   { name: "Electric Unit", code: "ELEU" },
//   { name: "Eth Panthiya", code: "ETPN" },
//   { name: "Ehelapola Walauwa", code: "EHPW" },
//   { name: "Account Office", code: "ACCT" },
//   { name: "Cleaning Unit (Garison)", code: "CLGR" },
//   { name: "Hewisi Team", code: "HEWS" },
//   { name: "Foreign Buddhist Affairs", code: "FBAF" },
//   { name: "Kavikara Maduwa", code: "KVKM" },
//   { name: "Land Office", code: "LAND" },
//   { name: "Local Buddhist Affairs", code: "LBAF" },
//   { name: "Library", code: "LIBR" },
//   { name: "Muluthange", code: "MLTG" },
//   { name: "Maintenance Unit", code: "MANT" },
//   { name: "Mahamaluwa", code: "MAHA" },
//   { name: "Media and Special Projects Bureau", code: "MSPR" },
//   { name: "Hon. Diyawadana Nilame Home", code: "DWNB" },
//   { name: "Pilgrim Rest (New)", code: "PGRN" },
//   { name: "New Shrine Room", code: "NSRM" },
//   { name: "Perahere Office", code: "PRHO" },
//   { name: "Pallekale", code: "PALK" },
//   { name: "Lighting Stall", code: "LMPS" },
//   { name: "Inquring and Reception", code: "RECP" },
//   { name: "Raja Etha Museum", code: "RAJA" },
//   { name: "Scholarship Project Office", code: "SCHP" },
//   { name: "Souvenir Shop", code: "SOUV" },
//   { name: "Stores", code: "STOS" },
//   { name: "Transport Unit", code: "TRAP" },
//   { name: "Udamale", code: "UDML" },
//   { name: "Vidanewaru", code: "VDNW" },
//   { name: "World Buddhist Museum", code: "WBMS" },
//   { name: "Paththirippuwa", code: "PTPW" },
//   { name: "Kariya Karawana Korala", code: "KKKL" },
//   { name: "Foreign Ticket Checker", code: "FRTC" },
//   { name: "Alaththi Ammawaru", code: "ALAM" }
// ];

// // ------------ Styles ------------
// const PageContainer = styled(Box)(({ theme }) => ({
//   maxWidth: "1000px",
//   margin: "0 auto",
//   padding: "8px 12px",
//   fontFamily: "'Poppins', sans-serif",
//   [theme.breakpoints.down("sm")]: {
//     padding: "0px 8px",
//   },
// }));

// const StickyCardsContainer = styled(Box)(({ theme }) => ({
//   position: "sticky",
//   top: 0,
//   backgroundColor: "#ffffff",
//   zIndex: 100,
//   paddingTop: "0px",
//   paddingBottom: "4px",
//   boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
//   [theme.breakpoints.down("sm")]: {
//     position: "sticky",
//     top: 0,
//     backgroundColor: "#ffffff",
//   },
// }));

// const ScrollableContent = styled(Box)(({ theme }) => ({
//   [theme.breakpoints.down("sm")]: {
//     maxHeight: "calc(100vh - 260px)",
//     overflowY: "auto",
//   },
// }));

// const EmployeeCard = styled(Box)(({ theme }) => ({
//   padding: "10px 12px",
//   borderRadius: "10px",
//   marginBottom: "8px",
//   boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.07)",
//   backgroundColor: "#fff",
//   border: "1px solid #d1d9e6",
//   transition: "0.15s ease",
//   "&:hover": {
//     backgroundColor: "rgba(14, 60, 102, 0.06)",
//     cursor: "pointer",
//     transform: "translateY(-1px)",
//     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.12)",
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "8px 10px",
//   },
// }));

// // Table Styles matching LocationBasedEmp.js
// const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
//   borderRadius: "10px",
//   boxShadow: "0px 3px 8px rgba(0,0,0,0.07)",
//   border: "1px solid #d1d9e6",
//   backgroundColor: "#ffffff",
//   overflow: "hidden",
//   "& .MuiTable-root": {
//     borderCollapse: "separate",
//     borderSpacing: 0,
//   },
//   "&::-webkit-scrollbar": {
//     width: "5px",
//   },
//   "&::-webkit-scrollbar-thumb": {
//     backgroundColor: "#888",
//     borderRadius: "2px",
//   },
//   "&::-webkit-scrollbar-thumb:hover": {
//     backgroundColor: "#555",
//   },
//   [theme.breakpoints.up("sm")]: {
//     maxHeight: "500px", // Fixed height for scrolling
//     overflowY: "auto",
//     overflowX: "auto",
//   },
//   [theme.breakpoints.down("sm")]: {
//     maxHeight: "500px",
//     overflowY: "auto",
//     overflowX: "auto",
//   },
// }));

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontFamily: "'Poppins', sans-serif",
//   padding: "8px 6px",
//   fontSize: "13px",
//   textAlign: "center",
//   "&.MuiTableCell-head": {
//     backgroundColor: "#154c79",
//     color: "#ffffff",
//     fontWeight: 600,
//     letterSpacing: "0.3px",
//     borderBottom: "none",
//     position: "sticky",
//     top: 0,
//     zIndex: 10,
//     "&:first-of-type": {
//       borderTopLeftRadius: "10px",
//     },
//     "&:last-of-type": {
//       borderTopRightRadius: "10px",
//     },
//   },
//   [theme.breakpoints.down("sm")]: {
//     padding: "6px 4px",
//     fontSize: "11px",
//     "&.MuiTableCell-head": {
//       fontSize: "12px",
//     },
//   },
// }));

// const StyledTableRow = styled(TableRow)(() => ({
//   transition: "0.15s ease",
//   "&:nth-of-type(odd)": {
//     backgroundColor: "rgba(243, 246, 250, 0.6)",
//   },
//   "&:hover": {
//     backgroundColor: "rgba(14, 60, 102, 0.06)",
//     cursor: "pointer",
//   },
//   "&:last-of-type td:first-of-type": {
//     borderBottomLeftRadius: "10px",
//   },
//   "&:last-of-type td:last-of-type": {
//     borderBottomRightRadius: "10px",
//   },
// }));

// export default function EmpDiscripency() {
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const { loading, data, summaryLoading, summaryData } = useSelector(
//     (state) => state.empDiscripency
//   );

//   const [openDatePicker, setOpenDatePicker] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [selectedLocation, setSelectedLocation] = useState("");
//   const [viewMode, setViewMode] = useState("summary");
//   const [exportProgress, setExportProgress] = useState(0);
//   const [exporting, setExporting] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   const formatDate = (dateObj) => {
//     const d = new Date(dateObj);
//     return d.toISOString().split("T")[0];
//   };

//   // Load attendance summary on mount and when date changes
//   useEffect(() => {
//     dispatch(fetchAttendanceSummary(formatDate(selectedDate)));
//   }, [dispatch, selectedDate]);

//   // Load absent details when location is selected
//   useEffect(() => {
//     if (selectedLocation && viewMode === "details") {
//       dispatch(fetchEmpDiscripency(formatDate(selectedDate), selectedLocation));
//     }
//   }, [dispatch, selectedDate, selectedLocation, viewMode]);

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//     setOpenDatePicker(false);
//     setViewMode("summary");
//     setSelectedLocation("");
//   };

//   const handleLocationChange = (event) => {
//     const value = event.target.value;
//     setSelectedLocation(value);
    
//     if (value === "") {
//       // When "All Locations" is selected, go back to summary view
//       setViewMode("summary");
//     } else {
//       // When a specific location is selected, go to details view
//       setViewMode("details");
//     }
//   };

//   const handleLocationCardClick = (locationName) => {
//     const location = LOCATION_MAP.find((loc) => loc.name === locationName);
//     if (location) {
//       setSelectedLocation(location.code);
//       setViewMode("details");
//     }
//   };

//   const handleBackToSummary = () => {
//     setViewMode("summary");
//     setSelectedLocation(""); // Reset the dropdown
//   };

//   // Notification handlers
//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({
//       open: true,
//       message,
//       severity,
//     });
//   };

//   const closeSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const totalEmployees = data?.length || 0;

//   // Calculate totals from summary
//   const summaryTotals = useMemo(() => {
//     if (!summaryData || !Array.isArray(summaryData)) {
//       return { totalEmp: 0, todayAtt: 0 };
//     }
//     return summaryData.reduce(
//       (acc, item) => ({
//         totalEmp: acc.totalEmp + parseInt(item.TotalEmp || 0),
//         todayAtt: acc.todayAtt + parseInt(item.TodayAtt || 0),
//       }),
//       { totalEmp: 0, todayAtt: 0 }
//     );
//   }, [summaryData]);

//   const totalAbsent = summaryTotals.totalEmp - summaryTotals.todayAtt;
//   const activePercentage =
//     summaryTotals.totalEmp > 0
//       ? Math.round((summaryTotals.todayAtt / summaryTotals.totalEmp) * 100)
//       : 0;

//   // Sort summary data by absent count (descending)
//   const sortedSummaryData = useMemo(() => {
//     if (!summaryData || !Array.isArray(summaryData)) return [];
//     return [...summaryData].sort((a, b) => {
//       const absentA = parseInt(a.TotalEmp || 0) - parseInt(a.TodayAtt || 0);
//       const absentB = parseInt(b.TotalEmp || 0) - parseInt(b.TodayAtt || 0);
//       return absentB - absentA;
//     });
//   }, [summaryData]);

//   // Enhanced Export PDF for Summary with progress
//   const handleExportSummaryPDF = async () => {
//     if (exporting) return;
    
//     try {
//       setExporting(true);
//       setExportProgress(10);
      
//       // Simulate PDF generation steps
//       const doc = new jsPDF("p", "mm", "a4");
//       const pageWidth = doc.internal.pageSize.getWidth();
//       const pageHeight = doc.internal.pageSize.getHeight();

//       setExportProgress(20);

//       // Title and header
//       doc.setFontSize(20);
//       doc.setFont("helvetica", "bold");
//       doc.text("Attendance Summary Report", pageWidth / 2, 20, { align: "center" });

//       setExportProgress(30);

//       doc.setFontSize(12);
//       doc.setFont("helvetica", "normal");
//       doc.text(`Report Date: ${formatDate(selectedDate)}`, 20, 35);
//       doc.text(`Total Employees: ${summaryTotals.totalEmp}`, 20, 42);
//       doc.text(`Present: ${summaryTotals.todayAtt} (${activePercentage}%)`, 20, 49);
//       doc.text(`Absent: ${totalAbsent}`, 20, 56);

//       setExportProgress(50);

//       // Generate table
//       autoTable(doc, {
//         startY: 65,
//         head: [["Location", "Strength", "Present", "Absent", "Attendance %"]],
//         body: sortedSummaryData?.map((item) => {
//           const present = parseInt(item.TodayAtt || 0);
//           const total = parseInt(item.TotalEmp || 0);
//           const absent = total - present;
//           const percentage = total > 0 ? Math.round((present / total) * 100) : 0;
          
//           return [
//             item.location || "",
//             total.toString(),
//             present.toString(),
//             absent.toString(),
//             `${percentage}%`,
//           ];
//         }),
//         styles: {
//           fontSize: 9,
//           cellPadding: 4,
//         },
//         headStyles: {
//           fillColor: [21, 76, 121],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//         alternateRowStyles: {
//           fillColor: [245, 248, 252],
//         },
//         foot: [
//           [
//             "TOTAL",
//             summaryTotals.totalEmp.toString(),
//             summaryTotals.todayAtt.toString(),
//             totalAbsent.toString(),
//             `${activePercentage}%`,
//           ],
//         ],
//         footStyles: {
//           fillColor: [21, 76, 121],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//       });

//       setExportProgress(80);

//       // Add footer
//       const pageCount = doc.internal.getNumberOfPages();
//       for (let i = 1; i <= pageCount; i++) {
//         doc.setPage(i);
//         doc.setFontSize(10);
//         doc.setTextColor(128, 128, 128);
//         doc.text(
//           `Page ${i} of ${pageCount}`,
//           pageWidth - 20,
//           pageHeight - 10,
//           { align: "right" }
//         );
//         doc.text(
//           `Generated on ${new Date().toLocaleDateString()}`,
//           20,
//           pageHeight - 10
//         );
//       }

//       setExportProgress(100);

//       // Save the PDF
//       doc.save(`Attendance_Summary_${formatDate(selectedDate)}.pdf`);
      
//       // Show success notification
//       showSnackbar("Summary report exported successfully!", "success");
      
//       // Reset progress
//       setTimeout(() => {
//         setExporting(false);
//         setExportProgress(0);
//       }, 1000);
      
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       showSnackbar("Failed to export PDF. Please try again.", "error");
//       setExporting(false);
//       setExportProgress(0);
//     }
//   };

//   // Enhanced Export PDF for Absent Details with progress
//   const handleExportAbsentPDF = async () => {
//     if (exporting) return;
    
//     try {
//       setExporting(true);
//       setExportProgress(10);

//       const doc = new jsPDF("p", "mm", "a4");
//       const pageWidth = doc.internal.pageSize.getWidth();
//       const pageHeight = doc.internal.pageSize.getHeight();

//       setExportProgress(20);

//       const selectedLocationName =
//         LOCATION_MAP.find((loc) => loc.code === selectedLocation)?.name ||
//         "All Locations";

//       // Title and header
//       doc.setFontSize(20);
//       doc.setFont("helvetica", "bold");
//       doc.text("Employee Absent Report", pageWidth / 2, 20, { align: "center" });

//       setExportProgress(30);

//       doc.setFontSize(12);
//       doc.setFont("helvetica", "normal");
//       doc.text(`Report Date: ${formatDate(selectedDate)}`, 20, 35);
//       doc.text(`Location: ${selectedLocationName}`, 20, 42);
//       doc.text(`Total Absent: ${totalEmployees}`, 20, 49);
//       doc.text(`Generated: ${new Date().toLocaleString()}`, 20, 56);

//       setExportProgress(50);

//       // Generate table
//       autoTable(doc, {
//         startY: 65,
//         head: [["No", "Service No", "Employee Name", "Location", "Position"]],
//         body: data?.map((item, index) => [
//           (index + 1).toString(),
//           item.sno || "N/A",
//           item.name || "N/A",
//           item.locationName || "N/A",
//           item.position || "N/A",
//         ]),
//         styles: {
//           fontSize: 9,
//           cellPadding: 4,
//         },
//         headStyles: {
//           fillColor: [21, 76, 121],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//         alternateRowStyles: {
//           fillColor: [245, 248, 252],
//         },
//         foot: [
//           [
//             "",
//             "",
//             "",
//             "Total Absent:",
//             totalEmployees.toString(),
//           ],
//         ],
//         footStyles: {
//           fillColor: [21, 76, 121],
//           textColor: 255,
//           fontStyle: "bold",
//         },
//       });

//       setExportProgress(80);

//       // Add footer
//       const pageCount = doc.internal.getNumberOfPages();
//       for (let i = 1; i <= pageCount; i++) {
//         doc.setPage(i);
//         doc.setFontSize(10);
//         doc.setTextColor(128, 128, 128);
//         doc.text(
//           `Page ${i} of ${pageCount}`,
//           pageWidth - 20,
//           pageHeight - 10,
//           { align: "right" }
//         );
//       }

//       setExportProgress(100);

//       // Save the PDF
//       doc.save(
//         `Absent_Report_${selectedLocationName.replace(/\s+/g, '_')}_${formatDate(selectedDate)}.pdf`
//       );
      
//       // Show success notification
//       showSnackbar("Absent report exported successfully!", "success");
      
//       // Reset progress
//       setTimeout(() => {
//         setExporting(false);
//         setExportProgress(0);
//       }, 1000);
      
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       showSnackbar("Failed to export PDF. Please try again.", "error");
//       setExporting(false);
//       setExportProgress(0);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <PageContainer>
//         {/* Export Progress Backdrop */}
//         <Backdrop
//           sx={{
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//             backgroundColor: "rgba(0, 0, 0, 0.7)",
//           }}
//           open={exporting}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 2,
//               p: 4,
//               bgcolor: "background.paper",
//               borderRadius: 2,
//               boxShadow: 24,
//               maxWidth: 400,
//               width: "100%",
//             }}
//           >
//             <CircularProgress
//               size={60}
//               thickness={4}
//               sx={{ color: "#154c79" }}
//             />
//             <Typography variant="h6" color="primary" fontWeight="bold">
//               {viewMode === "summary" 
//                 ? "Exporting Summary Report..." 
//                 : "Exporting Absent Report..."}
//             </Typography>
//             <Box sx={{ width: "100%", mt: 2 }}>
//               <LinearProgress
//                 variant="determinate"
//                 value={exportProgress}
//                 sx={{
//                   height: 10,
//                   borderRadius: 5,
//                   backgroundColor: "#e0e0e0",
//                   "& .MuiLinearProgress-bar": {
//                     backgroundColor: viewMode === "summary" ? "#154c79" : "#2e7d32",
//                   },
//                 }}
//               />
//               <Typography
//                 variant="body2"
//                 color="text.secondary"
//                 align="center"
//                 mt={1}
//               >
//                 {exportProgress}% Complete
//               </Typography>
//             </Box>
//             <Typography variant="body2" color="text.secondary" align="center">
//               {viewMode === "summary" 
//                 ? "Generating attendance summary report..." 
//                 : "Generating absent employee report..."}
//             </Typography>
//           </Box>
//         </Backdrop>

//         {/* Success/Error Snackbar */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={closeSnackbar}
//           anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         >
//           <Alert
//             onClose={closeSnackbar}
//             severity={snackbar.severity}
//             sx={{ width: "100%" }}
//             elevation={6}
//             variant="filled"
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>

//         <Typography
//           sx={{
//             fontSize: "16px",
//             fontWeight: 700,
//             color: "#0e3c66",
//             textAlign: "center",
//             mb: 1,
//           }}
//         >
//           {viewMode === "summary"
//             ? "Employee Absent List"
//             : "Employee Absent List"}
//         </Typography>

//         {/* Date Picker, Location Dropdown, and Export Button */}
//         <Box
//           sx={{
//             display: "flex",
//             gap: 1,
//             mb: 1.5,
//             alignItems: "center",
//             flexWrap: isMobile ? "wrap" : "nowrap",
//           }}
//         >
//           <Button
//             variant="contained"
//             startIcon={<CalendarTodayIcon />}
//             onClick={() => setOpenDatePicker(true)}
//             disabled={exporting}
//             sx={{
//               flex: isMobile ? 1 : 2,
//               minWidth: isMobile ? "calc(50% - 4px)" : "auto",
//               height: "38px",
//               borderRadius: "8px",
//               backgroundColor: exporting ? "#9e9e9e" : "#154c79",
//               color: "#fff",
//               fontWeight: "bold",
//               textTransform: "none",
//               fontSize: "13px",
//               "&:hover": { 
//                 backgroundColor: exporting ? "#9e9e9e" : "#0D47A1" 
//               },
//             }}
//           >
//             {formatDate(selectedDate)}
//           </Button>

//           <FormControl
//             sx={{
//               flex: isMobile ? 1 : 2,
//               minWidth: isMobile ? "calc(50% - 4px)" : "auto",
//             }}
//           >
//             <Select
//               value={selectedLocation}
//               onChange={handleLocationChange}
//               displayEmpty
//               disabled={exporting}
//               sx={{
//                 height: "38px",
//                 borderRadius: "8px",
//                 fontSize: "13px",
//                 fontWeight: "bold",
//                 backgroundColor: exporting ? "#f5f5f5" : "#ffffff",
//                 "& .MuiOutlinedInput-notchedOutline": {
//                   borderColor: exporting ? "#e0e0e0" : undefined,
//                 },
//               }}
//             >
//               <MenuItem value="">
//                 <em>All Locations</em>
//               </MenuItem>
//               {LOCATION_MAP.map((location) => (
//                 <MenuItem key={location.code} value={location.code}>
//                   {location.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {!summaryLoading && summaryData && summaryData.length > 0 && (
//             <Button
//               variant="contained"
//               startIcon={<PictureAsPdfIcon />}
//               onClick={
//                 viewMode === "summary"
//                   ? handleExportSummaryPDF
//                   : handleExportAbsentPDF
//               }
//               disabled={exporting || (viewMode === "details" && (!data || data.length === 0))}
//               sx={{
//                 flex: isMobile ? 1 : 1,
//                 minWidth: isMobile ? "100%" : "auto",
//                 height: "38px",
//                 borderRadius: "8px",
//                 backgroundColor: exporting 
//                   ? "#9e9e9e" 
//                   : (viewMode === "details" && (!data || data.length === 0) 
//                     ? "#bdbdbd" 
//                     : viewMode === "summary" 
//                     ? "#097721" 
//                     : "#2e7d32"),
//                 color: "#fff",
//                 fontWeight: "bold",
//                 textTransform: "none",
//                 fontSize: "13px",
//                 "&:hover": { 
//                   backgroundColor: exporting 
//                     ? "#9e9e9e" 
//                     : (viewMode === "details" && (!data || data.length === 0) 
//                       ? "#bdbdbd" 
//                       : viewMode === "summary" 
//                       ? "#0D47A1" 
//                       : "#1b5e20") 
//                 },
//               }}
//             >
//               {exporting ? "Exporting..." : "Export PDF"}
//             </Button>
//           )}
//         </Box>

//         {openDatePicker && (
//           <DatePicker
//             open={openDatePicker}
//             onClose={() => setOpenDatePicker(false)}
//             value={selectedDate}
//             onChange={handleDateChange}
//             slotProps={{ textField: { sx: { display: "none" } } }}
//           />
//         )}

//         {/* Sticky Stats Cards */}
//         {!summaryLoading && summaryData && summaryData.length > 0 && (
//           <StickyCardsContainer>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "6px",
//               }}
//             >
//               {/* Total Strength Card */}
//               <Box
//                 sx={{
//                   background: "linear-gradient(135deg, #e8f0fa 0%, #d4e3f7 100%)",
//                   border: "1px solid #aec4e0",
//                   padding: "6px 8px",
//                   borderRadius: "6px",
//                   textAlign: "center",
//                   fontWeight: 600,
//                   color: "#0E3C66",
//                   flex: 1,
//                   minWidth: 0,
//                 }}
//               >
//                 <Typography
//                   sx={{ fontSize: isMobile ? "9px" : "10px", fontWeight: 500, mb: 0.2 }}
//                 >
//                   Total Strength
//                 </Typography>
//                 <Typography sx={{ fontSize: isMobile ? "15px" : "18px", fontWeight: 800 }}>
//                   {summaryTotals.totalEmp}
//                 </Typography>
//               </Box>

//               {/* Attendance Card */}
//               <Box
//                 sx={{
//                   background: "linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%)",
//                   border: "1px solid #80cbc4",
//                   padding: "6px 8px",
//                   borderRadius: "6px",
//                   textAlign: "center",
//                   fontWeight: 600,
//                   color: "#004d40",
//                   flex: 1,
//                   minWidth: 0,
//                 }}
//               >
//                 <Typography
//                   sx={{ fontSize: isMobile ? "9px" : "10px", fontWeight: 500, mb: 0.2 }}
//                 >
//                   Attendance
//                 </Typography>
//                 <Typography sx={{ fontSize: isMobile ? "15px" : "18px", fontWeight: 800 }}>
//                   {summaryTotals.todayAtt}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: isMobile ? "9px" : "10px",
//                     fontWeight: 700,
//                     color:
//                       activePercentage > 70
//                         ? "#2E7D32"
//                         : activePercentage > 50
//                         ? "#FF9800"
//                         : "#D32F2F",
//                   }}
//                 >
//                   ({activePercentage}%)
//                 </Typography>
//               </Box>

//               {/* Absent Card */}
//               <Box
//                 sx={{
//                   background: "linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)",
//                   border: "1px solid #ef9a9a",
//                   padding: "6px 8px",
//                   borderRadius: "6px",
//                   textAlign: "center",
//                   fontWeight: 600,
//                   color: "#b71c1c",
//                   flex: 1,
//                   minWidth: 0,
//                 }}
//               >
//                 <Typography
//                   sx={{ fontSize: isMobile ? "9px" : "10px", fontWeight: 500, mb: 0.2 }}
//                 >
//                   Absent
//                 </Typography>
//                 <Typography sx={{ fontSize: isMobile ? "15px" : "18px", fontWeight: 800 }}>
//                   {totalAbsent}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: isMobile ? "9px" : "10px",
//                     fontWeight: 700,
//                     color: "#D32F2F",
//                   }}
//                 >
//                   ({100 - activePercentage}%)
//                 </Typography>
//               </Box>
//             </Box>
//           </StickyCardsContainer>
//         )}

//         <ScrollableContent>
//           {viewMode === "summary" ? (
//             // Summary View - TABLE with all locations and scroll
//             summaryLoading ? (
//               <Box sx={{ textAlign: "center", padding: "40px" }}>
//                 <CircularProgress sx={{ color: "#154c79" }} />
//               </Box>
//             ) : sortedSummaryData && sortedSummaryData.length > 0 ? (
//               <StyledTableContainer component={Paper} sx={{ mt: 2 }}>
//                 <Table stickyHeader>
//                   <TableHead>
//                     <TableRow>
//                       <StyledTableCell>Location</StyledTableCell>
//                       <StyledTableCell>Strength</StyledTableCell>
//                       <StyledTableCell>Absent</StyledTableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {sortedSummaryData.map((row, index) => {
//                       const absentCount = parseInt(row.TotalEmp || 0) - parseInt(row.TodayAtt || 0);
                      
//                       return (
//                         <StyledTableRow 
//                           key={index}
//                           onClick={() => handleLocationCardClick(row.location)}
//                         >
//                           <StyledTableCell
//                             sx={{
//                               textAlign: "left",
//                               pl: isMobile ? 2 : 3,
//                               maxWidth: "200px",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap",
//                             }}
//                           >
//                             {row.location}
//                           </StyledTableCell>
//                           <StyledTableCell>{row.TotalEmp}</StyledTableCell>
//                           <StyledTableCell>
//                             <Typography
//                               sx={{
//                                 fontWeight: 700,
//                                 color: absentCount > 0 ? "#D32F2F" : "#2E7D32",
//                                 fontSize: "13px",
//                               }}
//                             >
//                               {absentCount}
//                             </Typography>
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       );
//                     })}
                    
//                     {/* Total Row */}
//                     <StyledTableRow
//                       sx={{
//                         backgroundColor: "#154c79 !important",
//                         "&:hover": { backgroundColor: "#154c79 !important" },
//                         position: "sticky",
//                         bottom: 0,
//                         zIndex: 5,
//                       }}
//                     >
//                       <StyledTableCell
//                         sx={{
//                           color: "#ffffff",
//                           fontWeight: 700,
//                           textAlign: "left",
//                           pl: isMobile ? 2 : 3,
//                         }}
//                       >
//                         Total
//                       </StyledTableCell>
//                       <StyledTableCell
//                         sx={{ color: "#ffffff", fontWeight: 700 }}
//                       >
//                         {summaryTotals.totalEmp}
//                       </StyledTableCell>
//                       <StyledTableCell
//                         sx={{ color: "#ffffff", fontWeight: 700 }}
//                       >
//                         {totalAbsent}
//                       </StyledTableCell>
//                     </StyledTableRow>
//                   </TableBody>
//                 </Table>
//               </StyledTableContainer>
//             ) : (
//               <Typography
//                 variant="body1"
//                 sx={{ textAlign: "center", padding: "40px", color: "#666", fontStyle: "italic" }}
//               >
//                 No attendance data available for the selected date
//               </Typography>
//             )
//           ) : (
//             // Details View - Employee Cards (Unchanged)
//             <>
//               {viewMode === "details" && (
//                 <Box sx={{ mb: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
//                   <Button
//                     variant="text"
//                     startIcon={<ArrowBackIcon />}
//                     onClick={handleBackToSummary}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: "bold",
//                       color: "#154c79",
//                       fontSize: "13px",
//                     }}
//                   >
//                     Absent List (by Location)
//                   </Button>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: "bold",
//                       color: "#D32F2F",
//                       fontSize: "13px",
//                     }}
//                   >
//                     Total Absent: {totalEmployees}
//                   </Typography>
//                 </Box>
//               )}

//               {loading ? (
//                 <Box sx={{ textAlign: "center", padding: "40px" }}>
//                   <CircularProgress sx={{ color: "#154c79" }} />
//                 </Box>
//               ) : data && data.length > 0 ? (
//                 data.map((item, index) => (
//                   <EmployeeCard key={index}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                       {/* Employee Image */}
//                       <img
//                         src={`/api/placeholder/50/50`}
//                         alt={item.name}
//                         style={{
//                           width: "50px",
//                           height: "50px",
//                           borderRadius: "50%",
//                           objectFit: "cover",
//                           border: "2px solid #154c79",
//                         }}
//                         onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                       />

//                       {/* Employee Details */}
//                       <Box sx={{ flex: 1 }}>
//                         <Typography
//                           variant="caption"
//                           fontWeight="bold"
//                           sx={{ color: "#154c79", display: "block", fontSize: "11px" }}
//                         >
//                           {item.sno}
//                         </Typography>
//                         <Typography
//                           variant="body2"
//                           fontWeight="600"
//                           sx={{ fontSize: "14px" }}
//                         >
//                           {item.name}
//                         </Typography>
//                         <Typography
//                           variant="caption"
//                           sx={{ color: "#666", display: "block", fontSize: "11px" }}
//                         >
//                           {item.locationName}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </EmployeeCard>
//                 ))
//               ) : (
//                 <Typography
//                   variant="body1"
//                   sx={{ textAlign: "center", padding: "40px", color: "#666", fontStyle: "italic" }}
//                 >
//                   No absent employees found for the selected date and location
//                 </Typography>
//               )}
//             </>
//           )}
//         </ScrollableContent>
//       </PageContainer>
//     </LocalizationProvider>
//   );
// }